import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import React, { useEffect, useState } from "react";
import { AppRoutes } from "Router/AppRoutes";
import { AppProvider } from "./AppProvider";
import { EnvironmentInfo } from "./EnvironmentTools";
import { GlobalStyle } from "./global-style";

export const AppContents = (): React.ReactElement => {
  const [url, setUrl] = useState(window.location.href);

  useEffect(() => {
    if (window.location.href !== url) {
      document.getElementById("skip-to-main-link")?.focus();
      setUrl(window.location.href);
    }
  });

  return (
    <AppProvider>
      <ReactQueryDevtools initialIsOpen={false} />
      <EnvironmentInfo />
      <GlobalStyle />
      <AppRoutes />
    </AppProvider>
  );
};
